import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Avatar } from '../auth/Profile';
import { useMyPeople } from '../../hooks/usePeople';
import './MyPeople.css';

function PersonCard({ person, viewerFamily }) {
  return (
    <div className="person-card">
      <Avatar name={person.name} size="large" avatarUrl={person.avatar_url} />
      <div className="person-card-info">
        <strong className="person-card-name">{person.name}</strong>
        {person.family && person.family !== viewerFamily && (
          <span className="person-card-family-tag">{person.family}</span>
        )}
        {person.email && (
          <span className="person-card-email">{person.email}</span>
        )}
      </div>
    </div>
  );
}

function PeopleSection({ title, people, emptyMessage, viewerFamily }) {
  return (
    <section className="people-section">
      <h3 className="people-section-title">
        {title}
        <span className="people-section-count">{people.length}</span>
      </h3>
      {people.length === 0 ? (
        <p className="people-empty">{emptyMessage}</p>
      ) : (
        <div className="people-grid">
          {people.map(person => (
            <PersonCard key={person.id} person={person} viewerFamily={viewerFamily} />
          ))}
        </div>
      )}
    </section>
  );
}

export default function MyPeople() {
  useAuth();
  const { data, isLoading, error } = useMyPeople();

  if (isLoading) {
    return (
      <div className="my-people">
        <h2>My People</h2>
        <p className="people-status">Loading…</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="my-people">
        <h2>My People</h2>
        <p className="people-status error">Failed to load people.</p>
      </div>
    );
  }

  const familyName = data?.familyName;
  const family = data?.family || [];
  const isOwner = data?.isOwner || false;
  const owners = data?.owners || [];

  const hasFamily = !!familyName;
  const showOwners = isOwner;

  return (
    <div className="my-people">
      <h2>My People</h2>

      {hasFamily && (
        <PeopleSection
          title={`${familyName} Family`}
          people={family}
          emptyMessage="No other family members found."
          viewerFamily={familyName}
        />
      )}

      {!hasFamily && (
        <p className="people-status">Your account has no family set.</p>
      )}

      {showOwners && (
        <PeopleSection
          title="The Owners"
          people={owners}
          emptyMessage="No other owners found."
          viewerFamily={familyName}
        />
      )}

      {!showOwners && !hasFamily && (
        <p className="people-status">You are not listed as an owner.</p>
      )}
    </div>
  );
}
